import { ApiState, Action } from '../../../types';
import { serviceReducer, callService } from '../../../shared/hooks/serviceReducer';
import { GrievanceBasicItem } from '../../../services/types/Grievance';

export type SearchGrievanceAction =
  | Action<GrievanceBasicItem[], { query: string; onlyClosed?: boolean }>
  | {
      type: 'QUERY_NUMBER';
      query: string;
      onlyClosed?: boolean;
    };

const reducer = (
  state: ApiState<GrievanceBasicItem[], { query: string; onlyClosed?: boolean }>,
  action: SearchGrievanceAction
): ApiState<GrievanceBasicItem[], { query: string; onlyClosed?: boolean }> => {
  switch (action.type) {
    case 'QUERY_NUMBER': {
      return callService(state, { query: action.query, onlyClosed: action.onlyClosed });
    }
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
